import React, {useState} from "react";
import {Box} from "@mui/system";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import BasicOptionsMenu from "../../common/BasicOptionsMenu";
import useModalSetup from "../../hooks/useModalSetup";
import ExpertPaymentActionModal from "./ExpertPaymentActionModal";
import {expertPaymentDescription} from "_constants";

export default function ExpertPaymentActions({handleClearState, selectedUserIds}) {
    const [actionType, setActionType] = useState({});
    const { handleOpenModal, handleCloseModal, openModal } = useModalSetup();

    const options = [
        {
            id: 'clear_balance',
            name: 'Clear balance',
            description: expertPaymentDescription.CLEAR_BALANCE(selectedUserIds.length),
        },
    ];

    const handleSelection = (selectedAction) => {
        setActionType(selectedAction);
        handleOpenModal();
    }

    return(
        <Box>
            <BasicOptionsMenu
                options={options}
                handleSelection={handleSelection}
                icon={<MoreHorizIcon sx={styles.icon}/>}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            />
            <ExpertPaymentActionModal
                title={actionType?.name ? `${actionType.name}` : 'Confirm action'}
                open={openModal}
                handleClose={handleCloseModal}
                handleClearState={handleClearState}
                selectedUserIds={selectedUserIds}
                actionType={actionType}
            />
        </Box>
    )
}


const styles = {
    icon: {
        color:'#003300',
        fontSize: '22px'
    }
}